import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ErrorService } from './ErrorService'
import { Router } from '@angular/router'
import { CareFinitySession } from './CareFinitySession'
import { AuthService } from '../../api/services'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private errorService: ErrorService, private router: Router, private authService: AuthService) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = ''
                if (error.error instanceof ErrorEvent) {
                    errorMessage = `An unexpected error occurred. We apologize for the inconvenience. If the problem persists, please contact support.`
                } else {
                    if (error.status >= 500)
                        errorMessage = `An unexpected error occurred on the server. We apologize for the inconvenience. If the problem persists, please contact support.`
                    else if (error.status == 401) {

                        if (
                            !req.url.includes("forgot/answerlist") &&
                            !req.url.includes("ValidateEmergencyToken")
                        ) {
                            console.log("api returned 401 redirecting user to login");
                            CareFinitySession.logout(this.authService);
                            this.router.navigate(["/login"]);
                        }

                    }
                    else if (error.status == 403) {
                        errorMessage = `You do not have access to the page or resource you are trying to reach. Please contact your administrator for more details.`
                    }
                    else if (!(error.status >= 400 && error.status < 500))
                        errorMessage = `The system is unable to connect to the server. You can try refreshing the page or logging out and logging in again. If the problem persists, please contact support.`
                }

                if (errorMessage) this.errorService.showError(errorMessage)

                return throwError(error)
            }),
        )
    }
}
